import { app } from '../resources/gcp-config';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const db = getFirestore(app);

export async function fetchQuoteDefaults() {
  try {
    const ref = doc(db, 'appSettings', 'quoteDefaults');
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      return { marginDefault: 0, gAndADefault: 0 };
    }
    const data = snap.data() || {};
    return {
      marginDefault: Number(data.marginDefault) || 0,
      gAndADefault: Number(data.gAndADefault) || 0,
    };
  } catch (e) {
    console.error('Error fetching quote defaults:', e);
    return { marginDefault: 0, gAndADefault: 0 };
  }
}


